import {
  ReactElement, useEffect, useMemo, useState,
} from 'react';
import { useTranslation } from 'react-i18next';
import { Option, SetGoalsResponse } from '../../types';
import { FormModalContainer } from './styles';
import { EnergyConsumptionForm } from '../Form';
import { DefaultFormValues } from '../Form/types';
import { SelectSearchOption } from 'react-select-search';
import { NewSelectSearch } from '../NewSelectSearch';

interface FormModalContentProps {
  loading: boolean;
  unitOptions: Option[];
  onClose: () => void;
  onChangeUnit: (unit: Option) => void;
  onSuccess: (responses: SetGoalsResponse[]) => void;
  defaultUnit?: Option;
  defaultValues?: DefaultFormValues;
}

export function FormModalContent({
  defaultUnit,
  defaultValues,
  loading,
  unitOptions,
  onClose,
  onChangeUnit,
  onSuccess,
}: Readonly<FormModalContentProps>): ReactElement {
  const [unit, setUnit] = useState<string>();
  const { t } = useTranslation();

  const unitOptionsSearch = useMemo(
    (): SelectSearchOption[] => unitOptions.map((item) => ({
      name: item.label,
      value: item.value,
    })), [unitOptions],
  );

  function onSelectUnit(value: string | string[]): void {
    const newValue = value as string;
    const option = unitOptions.find((item) => item.value === newValue);
    if (option) {
      setUnit(newValue);
      onChangeUnit(option);
    }
  }

  useEffect(() => {
    if (defaultValues && defaultUnit) {
      setUnit(defaultUnit.value);
    }
  }, [defaultValues, defaultUnit]);

  useEffect(() => () => {
    setUnit(undefined);
  }, []);

  return (
    <FormModalContainer>
      <NewSelectSearch
        label={t('unidade')}
        options={unitOptionsSearch}
        value={unit ?? ''}
        onChange={onSelectUnit}
      />
      <EnergyConsumptionForm
        defaultValues={defaultValues}
        loading={loading}
        unitId={unit ?? ''}
        onCancel={onClose}
        onSuccess={onSuccess}
      />
    </FormModalContainer>
  );
}
